import mapTiles from 'helpers/map/mapTiles'

const createTileImagesAndWait = function(urls, startTime, resolve) {
  let tileReadycount = 0
  const div = document.getElementById('onLoadContainer')
  console.warn('DEBUG', `Waiting for ${urls.length} tiles to load`)
  urls.forEach(function(url) {
    const img = document.createElement('img')
    img.onload = function() {
      tileReadycount = tileReadycount + 1
      if (tileReadycount === urls.length) {
        resolve()
        console.warn('DEBUG', `Took ${Date.now() - startTime}ms for tiles to load`)
      }
      this.remove()
    }
    div.appendChild(img)
    img.src = url
  })
}

const waitForTilesToLoad = async mapType => {
  const startTime = Date.now()
  await new Promise(resolve => {
    const images = mapTiles(mapType)
    console.warn('WAIT FOR LOAD', images.length)
    if (images.length !== 0) createTileImagesAndWait(images.map(img => img.src), startTime, resolve)
  })
}

export default waitForTilesToLoad



// WEBPACK FOOTER //
// ./src/helpers/map/waitForTilesToLoad.js